exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link-text p{line-height:1.2;margin-bottom:0}.signupItemText{margin-left:30px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/dist/cjs.js!./src/pages/Signup/style.scss
// module id = 5974
// module chunks = 0